export default "<h1 align='center' style=\"margin-top: 3.5rem;\">{{'Not Implemented Yet!' | translate}}</h1>\n"